import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import CssTransition from "../../../component/layout/css-transition";

export default function UpdateModal({ id, updateId, modalOpen, setModalOpen, handleEditAssetEntry, userData, company_id }) {
  const modalContent = useRef(null);
  const [updateasset, setUpdateAsset] = useState({});
  const [assettype, setAssetType] = useState([]);
  useEffect(() => {
    if (Object.keys(id).length !== 0) {
      setUpdateAsset({
        ...updateasset,
        asset_type: id.asset_type,
        asset_name: id.asset_name,
      });
    }
  }, [id]);

  useEffect(() => {
    getAssetType();
  }, []);
  const getAssetType = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/assetType/byCompany`)
      .then((res) => {
        setAssetType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    
  };
  const handleUser = (e) => {
    const { name, value } = e.target;
    setUpdateAsset({ ...updateasset, [name]: value });
  };
  const EditAssetEntry = (event) => {
    event.preventDefault();
    handleEditAssetEntry(updateasset);
  };
  return (
    <>
      <CssTransition className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity" show={modalOpen} enter="transition ease-out duration-200" enterStart="opacity-0" enterEnd="opacity-100" leave="transition ease-out duration-100" leaveStart="opacity-100" leaveEnd="opacity-0" aria-hidden="true" />
      <CssTransition id={id} className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6" role="dialog" aria-modal="true" show={modalOpen} enter="transition ease-in-out duration-200" enterStart="opacity-0 translate-y-4" enterEnd="opacity-100 translate-y-0" leave="transition ease-in-out duration-200" leaveStart="opacity-100 translate-y-0" leaveEnd="opacity-0 translate-y-4">
        <div ref={modalContent} className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded shadow-lg flex flex-col">
          <div class="py-8 px-6 ">
            {/* Search form */}
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">Update Asset Entry</h3>
            <form class="w-full" onSubmit={EditAssetEntry}>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label for="name" class="block mb-2 text-sm font-medium text-gray-600 ">
                    Asset Type
                  </label>
                  <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 " name="asset_type" type="text" onChange={handleUser} value={updateasset.asset_type}>
                    {assettype.map((item) => {
                      return <option value={item.asset_type}>{item.asset_type}</option>;
                    })}
                  </select>
                </div>

                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label for="name" class="block mb-2 text-sm font-medium text-gray-900 ">
                    Asset Name
                  </label>
                  <input name="asset_name" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " value={updateasset.asset_name} required onChange={handleUser} />
                </div>
              </div>

              <div class="flex justify-end">
                <button
                  class="!bg-white border-slate-200 hover:border-slate-300 text-slate-600 rounded-lg text-sm px-5 py-2.5 mr-3"
                  type="button"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  Cancel
                </button>
                <button class="!bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white rounded-lg text-sm px-5 py-2.5 " type="Submit">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* {error ? (
          <div
            role="alert"
            style={{ position: "absolute", left: "10px", bottom: "0px" }}
          >
            
            <div class="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
              <p>Something went Wrong! Try again later</p>
            </div>
          </div>
        ) : null} */}
      </CssTransition>
    </>
  );
}
